<template>
  <section id="footer">
    <div class="footer-inner">
      <ul class="link-area">
        <li class="privacyPolicy" @click="openPrivacyPolicy()">
          개인정보처리방침
        </li>
        <li v-if="TOSFlag" @click="openTOS()">이용약관</li>
      </ul>
      <div class="info-area">
        <ul>
          <li>대표이사 : 조재억</li>
          <li>사업자등록번호 : 504-81-86794</li>
        </ul>
        <ul>
          <li>대표번호 : 070-5001-3711</li>
          <li>팩스 : 070-4015-0226</li>
          <li>이메일 : info@ubi-plus.com</li>
        </ul>
        <ul>
          <li>
            주소 : 강원특별자치도 춘천시 후석로420번길 7, 820호 (후평동,
            하이테크타워)
          </li>
          <li>개인정보관리책임자 : 김민석</li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Common-Footer",
  data() {
    return {
      TOSFlag: false,
      location: "",
    };
  },
  mounted() {
    const host = window.location.host;
    const hostArr = host.split(".");
    this.location = hostArr[0];

    if (this.location === "mindstrong") {
      this.TOSFlag = false;
    } else {
      this.TOSFlag = true;
    }
  },
  methods: {
    openPrivacyPolicy() {
      if (this.location === "mindstrong") {
        // url 주소 입력
        window.open(
          "https://mindstrong.ubi-plus.co.kr/mindstrong_privacy_policy.html",
          "_blank"
        );
      } else {
        window.open(
          "https://astop.ubi-plus.co.kr/astop_privacy_policy.html",
          "_blank"
        );
      }
    },
    openTOS() {
      window.open("https://astop.ubi-plus.co.kr/astop_TOS.html", "_blank");
      // 이용약관 오픈
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #f2f2f2;
  font-size: 14px;
  font-weight: 400;
}

.footer-inner {
  width: 90%;
  margin: auto;
  padding: 30px 0;
}

.link-area {
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  gap: 20px;
}

.link-area > li {
  cursor: pointer;
}

.info-area > ul {
  display: flex;
}

.info-area > ul:not(:last-child) {
  margin-bottom: 8px;
}

.info-area > ul > li:not(:last-child) {
  margin-right: 30px;
}
</style>
